import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CategoryListItem from './CategoryListItem';

export default class CategoryList extends Component {
  constructor(props) {
    super(props);
    this.renderList = this.renderList.bind(this);
    this.handleClickMore = this.handleClickMore.bind(this);
  }

  handleClickMore(e) {
    if (e) {
      e.preventDefault();
    }
    const { handleOpen, isOpenCategory } = this.props;
    if (handleOpen) {
      handleOpen(!isOpenCategory);
      if (!isOpenCategory) {
        setTimeout(() => {
          const nextCategory = findDOMNode(this.refs.category12);
          if (!!nextCategory) {
              nextCategory.querySelector('a').focus();
          }
        }, 100);
      }
    }
  }
  
  renderList() {
    const { categories, isOpenCategory, defaultCategoryCount } = this.props;
    return categories.map((category, idx) => {
      if ((!isOpenCategory) && idx >= defaultCategoryCount ) {
        return null;
      }
      return (
        <CategoryListItem
          key={category.get('id')}
          id={category.get('id')}
          name={category.get('name')}
          seq={idx}
          imageUrl={category.getIn(['icon','medium'])}
          ref={`category${idx}`}
        />
      );  
    });
  }
  
  render () {
    const { categories, isOpenCategory, defaultCategoryCount } = this.props;
    if (!categories.size) {
      return null;
    }
    const isNeedMoreTab = categories.size > defaultCategoryCount;
    return (
      <div>
        <h4 className="screen_out">카테고리</h4>
        <ul className="list_cate">
          { this.renderList() }
        </ul>
        {isNeedMoreTab && (
          <div data-tiara-layer="more">
            <a
              className={classnames('link_more', { on: isOpenCategory })}
              href="#more"
              role="button"
              aria-expanded={isOpenCategory ? "true" : "false"}
              onClick={(e) => {this.handleClickMore(e);}}
              data-tiara-layer={isOpenCategory ? 'close' : 'open'}
            >
              <span className="ico_plus ico_arr" />
              {isOpenCategory ? '카테고리 닫기' : '카테고리 전체보기'}
            </a>
          </div>
        )}
      </div>
    );
  }
}

CategoryList.propTypes = {
  categories: PropTypes.object.isRequired,
  handleOpen: PropTypes.func,
  isOpenCategory: PropTypes.bool,
  defaultCategoryCount: PropTypes.number
};

CategoryList.defaultProps = {
  isOpenCategory: false,
  defaultCategoryCount: 12
};


// WEBPACK FOOTER //
// ./src/components/CategoryList/index.js